var exports = {
  "k": "xa15a2ab7--5990e4--container",
};

module.exports = exports;
